import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { LoggerService } from '../../services/logger.service';
import { Product } from "../../models/product.model";
import { ProductsService } from "../../services/products.service";
import { cantidadesService } from "../../services/cantidades.service";
import {
    PopoverController,
    ModalController,
    LoadingController,
    IonInfiniteScroll,
    ToastController,
    NavController
} from "@ionic/angular";
import { GlobalService } from "../../services/global.service";
import { CartService } from "../../services/cart.service";
import { ApiService } from "../../api.service";
import { Storage } from "@ionic/storage";
import { Router, ActivatedRoute } from "@angular/router";
import { Carro } from "../../models/carro.model";
import { CategoryService } from "../../services/category.service";

import { ProductDetailsComponent } from "../../pages/product-details/product-details.component"


@Component({
    selector: 'app-linea-articulo-venta',
    templateUrl: './linea-articulo-venta.component.html',
    styleUrls: ['./linea-articulo-venta.component.scss'],
})
export class LineaArticuloVentaComponent implements OnInit {

    @ViewChild(IonInfiniteScroll, { static: false })
    infiniteScroll: IonInfiniteScroll;

    @Output() favEvent: EventEmitter<any> = new EventEmitter();

    @Input() products: Product[];
    @Input() grid: boolean;    
    @Input() item: Product;
    @Input() historico : boolean = false;

    private cartProducts: Carro;

    private incremento = 10;

    constructor(
        private navController: NavController,
        private activeRoute: ActivatedRoute,
        private cartService: CartService,
        private route: ActivatedRoute,
        private router: Router,
        public popoverController: PopoverController,
        private productsService: ProductsService,
        public storage: Storage,
        private logger: LoggerService,
        public ctdadService: cantidadesService,
        public modalController: ModalController,
        public global: GlobalService,
        public loadingController: LoadingController,
        public apiService: ApiService,
        public toastController: ToastController,
        private categoryService: CategoryService

    ) {
    }

    ngOnInit() {
    }

    async FavAdd(_product, e) {
        e.stopPropagation();

        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].codigo === _product) {
                await this.apiService.FavAdd(
                    this.products[i].codigo
                );
                this.products[i].isWishlist = true;
                this.global.cambio = true;
                this.favEvent.emit();
            }
        }
    }

    async FavDel(_product, e) {
        e.stopPropagation();

        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].codigo === _product) {
                await this.apiService.FavDel(
                    this.products[i].codigo
                );
                this.products[i].isWishlist = false;
                this.global.cambio = true;
                this.favEvent.emit();
            }
        }
    }

    async goToProductDetails(_product) {
        const modal = await this.modalController.create({
            component: ProductDetailsComponent,
            componentProps: { producto: _product },
        });
        return await modal.present();
    }

    /*
    async addtocart(_product, i) {
        this.logger.log("linea");
        _product = await this.apiService.dameUnidades(_product);
        await this.apiService.cartAdd(_product,false);
        this.global.searchTerm = "";
        this.getCartItems(_product.nombre);
    }*/


    async addtocart(_product, i) {
        _product = await this.apiService.dameUnidades(_product);
        await this.apiService.cartAdd(_product,false);
        this.global.searchTerm = "";
        this.cartService.cart().then((products) => {
            this.global.artcart = Object.keys(products.articulos).length;
            this.ctdadService.actualizaCantidadesPedidas(_product,products.articulos);
            this.logger.log( _product);
        });
        const toast = await this.toastController.create({
            message: _product.nombre + " añadido a tu carrito.",
            duration: 2000,
        });
        toast.present();
        //this.getCartItems(_product.nombre);
    }

    async getCartItems(_productName) {
        
        this.cartService.cart().then((products) => {
            this.cartProducts = products;
            const object = this.cartProducts.articulos;
            this.logger.log("Articulos carro: " + object);
            this.global.artcart = Object.keys(object).length;
        });
        const toast = await this.toastController.create({
            message: _productName + " añadido a tu carrito.",
            duration: 2000,
        });
        toast.present();
    }

    
    async compartir(_productName, e) {
        this.logger.log("compartir");
        e.stopPropagation();

        this.global.itemChat = _productName;
        this.router.navigate(['/tabs/tab2']);
    }
}
